/**
 * Checkout Stepper Component
 * Shows multi-step checkout progress
 */

import React from 'react';

const CheckoutStepper = ({ currentStep = 1 }) => {
  const steps = ['Cart', 'Shipping', 'Payment', 'Confirm'];

  return (
    <div className="checkout-stepper">
      {steps.map((step, index) => (
        <div 
          key={step} 
          className={`step ${index + 1 === currentStep ? 'active' : ''} ${index + 1 < currentStep ? 'completed' : ''}`}
        >
          <div className="step-number">{index + 1}</div>
          <div className="step-label">{step}</div>
        </div>
      ))}
    </div>
  );
};

export default CheckoutStepper;

